import React from 'react';
import { DebtStatusLogic } from '../../elements/DebtStatusLogic/debtStatusLogic';

export const Overview: React.FC = () => {
	return <DebtStatusLogic isDashboard={true} />;
};
